<!-- components/QuestionBank.vue -->
<template>
    <div class="question-bank-container">
      <!-- 左侧目录 -->
      <div class="sidebar">
        <el-card>
          <h3>教材目录</h3>
          <ChapterTree @chapter-change="onChapterChange" />
        </el-card>
      </div>
  
      <!-- 右侧内容区 -->
      <div class="main-content">
        <!-- 筛选区域 -->
        <el-card>
          <div class="filter-group">
            <div class="filter-item">
              <span class="label">场景：</span>
              <el-radio-group v-model="filters.scene" @change="fetchQuestions">
                <el-radio-button label="全部">全部</el-radio-button>
                <el-radio-button label="月考">月考</el-radio-button>
                <el-radio-button label="期中">期中</el-radio-button>
                <el-radio-button label="期末">期末</el-radio-button>
                <el-radio-button label="预习">预习</el-radio-button>
                <el-radio-button label="作业">作业</el-radio-button>
              </el-radio-group>
            </div>
  
            <div class="filter-item">
              <span class="label">题型：</span>
              <el-radio-group v-model="filters.type" @change="fetchQuestions">
                <el-radio-button label="全部">全部</el-radio-button>
                <el-radio-button label="单选题">单选题</el-radio-button>
                <el-radio-button label="多选题">多选题</el-radio-button>
                <el-radio-button label="填空题">填空题</el-radio-button>
                <el-radio-button label="解答题">解答题</el-radio-button>
                <el-radio-button label="判断题">判断题</el-radio-button>
              </el-radio-group>
            </div>
  
            <div class="filter-item">
              <span class="label">难度：</span>
              <el-radio-group v-model="filters.difficulty" @change="fetchQuestions">
                <el-radio-button label="全部">全部</el-radio-button>
                <el-radio-button label="容易">容易</el-radio-button>
                <el-radio-button label="较易">较易</el-radio-button>
                <el-radio-button label="适中">适中</el-radio-button>
                <el-radio-button label="较难">较难</el-radio-button>
                <el-radio-button label="困难">困难</el-radio-button>
              </el-radio-group>
            </div>
  
            <div class="filter-item">
              <span class="label">分类：</span>
              <el-radio-group v-model="filters.category" @change="fetchQuestions">
                <el-radio-button label="全部">全部</el-radio-button>
                <el-radio-button label="典型题">典型题</el-radio-button>
                <el-radio-button label="压轴题">压轴题</el-radio-button>
                <el-radio-button label="同步题">同步题</el-radio-button>
                <el-radio-button label="新文化题">新文化题</el-radio-button>
                <el-radio-button label="课本原题">课本原题</el-radio-button>
              </el-radio-group>
            </div>
          </div>
  
          <div class="more-filter">
            <span>更多：</span>
            <el-select v-model="filters.year" placeholder="年份" size="small" @change="fetchQuestions">
              <el-option label="全部" value=""></el-option>
              <el-option label="2024" value="2024"></el-option>
              <el-option label="2023" value="2023"></el-option>
            </el-select>
            <el-select v-model="filters.region" placeholder="地区" size="small" @change="fetchQuestions">
              <el-option label="全部" value=""></el-option>
              <el-option label="北京" value="北京"></el-option>
              <el-option label="上海" value="上海"></el-option>
            </el-select>
            <el-select v-model="filters.grade" placeholder="年级" size="small" @change="fetchQuestions">
              <el-option label="全部" value=""></el-option>
              <el-option label="高一" value="高一"></el-option>
              <el-option label="高二" value="高二"></el-option>
              <el-option label="高三" value="高三"></el-option>
            </el-select>
            <el-select v-model="filters.semester" placeholder="学期" size="small" @change="fetchQuestions">
              <el-option label="全部" value=""></el-option>
              <el-option label="上学期" value="上学期"></el-option>
              <el-option label="下学期" value="下学期"></el-option>
            </el-select>
            <el-checkbox v-model="filters.onlyNew" @change="fetchQuestions">只看新题</el-checkbox>
          </div>
        </el-card>
  
        <!-- 题目列表 -->
        <el-card style="margin-top: 20px;">
          <div class="toolbar">
            <el-button-group>
              <el-button type="primary" plain>综合</el-button>
              <el-button type="primary">最新</el-button>
              <el-button type="primary" plain>最热</el-button>
            </el-button-group>
            <el-input
              v-model="searchInResult"
              placeholder="在结果中搜索"
              prefix-icon="Search"
              clearable
              @input="debouncedSearch"
              style="width: 200px; margin-left: 20px;"
            />
            <span style="margin-left: auto; font-size: 14px;">共计 {{ total }} 道试题</span>
          </div>
  
          <div class="question-list">
            <QuestionCard
              v-for="q in questions"
              :key="q.id"
              :question="q"
              @add-to-basket="handleAddToBasket"
            />
          </div>
  
          <div class="pagination">
            <el-pagination
              v-model:current-page="currentPage"
              :page-size="pageSize"
              :total="total"
              layout="prev, pager, next, jumper, total"
              @current-change="fetchQuestions"
            />
          </div>
        </el-card>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, onMounted } from 'vue'
  import { ElMessage } from 'element-plus'
  import ChapterTree from '../components/ChapterTree.vue'
  import QuestionCard from '../components/QuestionCard2.vue'
  import { debounce } from 'lodash-es'
  
  const filters = reactive({
    scene: '全部',
    type: '全部',
    difficulty: '全部',
    category: '全部',
    year: '',
    region: '',
    grade: '',
    semester: '',
    onlyNew: false
  })
  
  const searchInResult = ref('')
  const currentPage = ref(1)
  const pageSize = 10
  const total = ref(0)
  const questions = ref([])
  
  // 模拟数据
  const mockQuestions = [
    {
      id: 'q1',
      type: '填空题',
      difficulty: '容易',
      difficultyScore: 0.94,
      source: '人教A版必修第一册',
      content: '1. 已知集合 $A = \\{m+5, m+1, 0\\}$，若 $4 \\in A$，则 $m=$ _______。',
  
      answer: '解：因为 $4 \\in A$，所以 $m+5=4$ 或 $m+1=4$，解得 $m=-1$ 或 $m=3$。但若 $m=3$，则 $A=\\{8,4,0\\}$，无重复元素；若 $m=-1$，则 $A=\\{4,0,0\\}$，有重复元素，不符合集合定义。故 $m=3$。',
      tags: ['集合', '元素'],
      date: '2024-03-15',
      usedCount: 2
    },
    {
      id: 'q2',
      type: '单选题',
      difficulty: '较易',
      difficultyScore: 0.85,
      source: '人教A版必修第一册',
      content: '下列函数是偶函数的是（　　）\n\nA. $f(x) = x^3$ \nB. $f(x) = |x|$ \nC. $f(x) = x+1$ \nD. $f(x) = \\frac{1}{x}$',
  
      answer: '解析：偶函数满足 $f(-x) = f(x)$。\n\nA. $f(-x) = (-x)^3 = -x^3 = -f(x)$ → 奇函数\nB. $f(-x) = |-x| = |x| = f(x)$ → 偶函数\nC. $f(-x) = -x+1 ≠ f(x)$\nD. $f(-x) = \\frac{1}{-x} = -\\frac{1}{x} = -f(x)$ → 奇函数\n\n正确答案：B',
      tags: ['函数', '奇偶性'],
      date: '2024-03-10',
      usedCount: 5
    }
  ]
  
  const fetchQuestions = () => {
    // 模拟请求
    setTimeout(() => {
      let filtered = mockQuestions.filter(q => {
        if (filters.scene !== '全部' && q.scene !== filters.scene) return false
        if (filters.type !== '全部' && q.type !== filters.type) return false
        if (filters.difficulty !== '全部' && q.difficulty !== filters.difficulty) return false
        if (filters.category !== '全部' && !q.tags.includes(filters.category)) return false
        if (filters.onlyNew && new Date(q.date) < new Date('2024-01-01')) return false
        return true
      })
  
      if (searchInResult.value) {
        filtered = filtered.filter(q =>
          q.content.toLowerCase().includes(searchInResult.value.toLowerCase()) ||
          q.answer?.toLowerCase().includes(searchInResult.value.toLowerCase())
        )
      }
  
      total.value = filtered.length
      questions.value = filtered.slice((currentPage.value - 1) * pageSize, currentPage.value * pageSize)
    }, 300)
  }
  
  const debouncedSearch = debounce(fetchQuestions, 500)
  
  const onChapterChange = (key) => {
    console.log('选中章节:', key)
    fetchQuestions()
  }
  
  const handleAddToBasket = (question) => {
    console.log('加入试题篮:', question)
    // 实际项目中可存入 Pinia 或 localStorage
    ElMessage.success(`《${question.content.substring(0, 20)}...》已加入试题篮`)
  }
  
  onMounted(() => {
    fetchQuestions()
  })
  </script>
  
  <style scoped>
  .question-bank-container {
    display: flex;
    gap: 20px;
    height: calc(100vh - 60px);
  }
  
  .sidebar {
    width: 280px;
    overflow-y: auto;
  }
  
  .main-content {
    flex: 1;
    overflow-y: auto;
  }
  
  .filter-group {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;
  }
  
  .filter-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .label {
    font-weight: bold;
    margin-right: 8px;
  }
  
  .more-filter {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px dashed #eee;
  }
  
  .toolbar {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  
  .question-list {
    min-height: 300px;
  }
  
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
  </style>